import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import BeamList from '../../beam/beam_list';

const AdrRow = ({ type, address1, city, stateAbbr, zip, classNamePrefix, className }) => {
  return (
    <TableRow className={className}>
      <TableCell className={classNamePrefix + 'type'}>{type}</TableCell>
      <TableCell className={classNamePrefix + 'address'}>{address1}</TableCell>
      <TableCell className={classNamePrefix + 'city'}>{city}</TableCell>
      <TableCell className={classNamePrefix + 'state'}>{stateAbbr}</TableCell>
      <TableCell className={classNamePrefix + 'zip'}>{zip}</TableCell>
    </TableRow>
  );
};

const HeaderCell = ({ label, className }) => <TableCell className={className}>{label}</TableCell>;

const Addresses = ({ classNamePrefix = '', addresses = [] }) => {
  return (
    <div className="addresses">
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <BeamList
                className={classNamePrefix ? `${classNamePrefix}-headers` : ''}
                list={[
                  { label: 'Type' },
                  { label: 'Address' },
                  { label: 'City' },
                  { label: 'State' },
                  { label: 'ZIP' },
                ]}
                childIdField={'label'}
              >
                <HeaderCell />
              </BeamList>
            </TableRow>
          </TableHead>
          <TableBody className={'qa-address-block'}>
            <BeamList
              className={classNamePrefix ? `${classNamePrefix}-rows` : ''}
              list={addresses?.sort((a, b) => a?.order - b?.order)}
              childIdField={'id'}
            >
              <AdrRow classNamePrefix={classNamePrefix} />
            </BeamList>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Addresses;
